import React from "react";
import { Box } from "@material-ui/core";
import { get } from "lodash";
import TargetColor from "../../../TargetColor/TargetColor";

const TargetType = colProps => {
  return (
    <td className="font-13">
      <Box display="flex" alignItems="center">
        <TargetColor targetType={get(colProps, "dataItem.type")} />
      </Box>
    </td>
  );
};

export default TargetType;
